<template>
    <BreadCrumb PageTitle="Modifier les informations d'un partenaire" />
    <EditPartenaire />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditPartenaire from "@/components/Partenaires/EditPartenaire.vue";

export default defineComponent({
    name:"EditPartenairePage",
    components: {
        BreadCrumb,
        EditPartenaire,
    },
});
</script>